import { Box } from "@mui/material";
import React from "react";
import styles from "./dashboardDealer.module.scss";
import Toggelbutton from "../../components/toggel/Toggelbutton";
import PropTypes from "prop-types";

export default function DashboardDealer(props) {
  const { Img, TextTitle, countValue, handleChange, alignment } = props;

  return (
    <Box className={styles.dealerWraperbox} data-testid="DashboardDealer">
      <Box className={styles.InsideDealerTextImg}>
        <Box className={styles.dealerImagWrapper}>
          <span className={Img}></span>
        </Box>
        <Box className={styles.RightDealerText}>{TextTitle}</Box>
      </Box>
      <Box className={styles.DealerMonthCount}>
        <Box className={styles.dealerToggle}>
          <Toggelbutton handelvalue={handleChange} selectedDay={alignment} />
        </Box>
        <Box className={styles.dealercount}>{countValue}</Box>
      </Box>
    </Box>
  );
}
DashboardDealer.propTypes = {
  Img: PropTypes.any, 
  TextTitle: PropTypes.any, 
  countValue: PropTypes.any, 
  handleChange: PropTypes.any, 
  alignment: PropTypes.any
}